module.exports = __webpack_public_path__ + "static/media/IPRO.d37a4139.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/IPRO.jpg
// module id = 1557
// module chunks = 1